import React from 'react';
import moment from 'moment';
import { PAYMENT_METHOD_TYPE } from '@src/constants/payment';
import { CONTACT_US_URL, VBEE_ZALO_URL } from '@src/configs';
import { getPriceText } from '@src/services/payment';
import { useMappingPackage } from '@src/hooks/useMappingPackage';
import { getPackageNameV3 } from '@src/services/package';
import { COLOR } from '@src/styles/color';
import CustomButton from '@src/new-components/Button';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import logo from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledDialog } from './index.styled';

const AutoRenewPriceAdjustmentPopup = ({
  open,
  onClose,
  releaseTime,
  usingStudioOrder,
  applyNewPriceAfterDays,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const { handleGetPackageCodeMapping, packages } = useMappingPackage();

  const packageCode = handleGetPackageCodeMapping({
    level: usingStudioOrder?.package?.level,
    type: usingStudioOrder?.packageInfo?.type,
    expiresIn: usingStudioOrder?.packageInfo?.expiresIn,
  });

  const packageInfo = usingStudioOrder?.packageInfo;
  const creditsPerCycle = packageInfo?.cycle?.creditsPerCycle;

  const ratio =
    creditsPerCycle && usingStudioOrder?.package?.cycle?.creditsPerCycle
      ? creditsPerCycle / usingStudioOrder?.package?.cycle?.creditsPerCycle
      : undefined;

  const packageMapping = packages.find((pkg) => pkg.code === packageCode);

  const priceAdjustment =
    packageMapping?.cycle?.creditOptions?.find(
      (option) =>
        ratio &&
        option.creditsPerCycle / packageMapping.cycle.creditsPerCycle === ratio,
    )?.autoRenewVndPrice ||
    packageMapping?.cycle?.creditOptions?.[0]?.autoRenewVndPrice;

  const newPrice = getPriceText(priceAdjustment, true, language);

  return (
    <StyledDialog open={open} onClose={onClose}>
      <div className="dialog-wrapper">
        <div className="logo">
          <img src={logo} alt="vbee tts logo" className="logo-img" />
        </div>
        <Typography variant="body-24-bold" color={COLOR.descriptionGray}>
          {t('titlePopupAdjustmentAutoRenewPrice')}
        </Typography>
        <div
          className="dialog-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('termContentPopupAdjustmentAutoRenewPrice', {
              fromDate: moment(releaseTime).format('DD/MM/YYYY'),
              applyNewPriceAfterDays: moment(releaseTime)
                .add(applyNewPriceAfterDays, 'days')
                .format('DD/MM/YYYY'),
              currentPackage: getPackageNameV3(
                usingStudioOrder?.package?.name,
                usingStudioOrder?.package?.code,
                language,
                t,
              ),
              newPrice,
              paymentMethod: usingStudioOrder?.paymentMethod?.source,
              prefixPayment:
                usingStudioOrder?.paymentMethod?.type ===
                PAYMENT_METHOD_TYPE.VNPAYQR
                  ? t('creditDebitCard')
                  : '',
            }),
          }}
        />
        <Typography
          variant="body-16-regular"
          color={COLOR.descriptionUpload}
          dangerouslySetInnerHTML={{
            __html: t('contactCS', {
              linkSupport: CONTACT_US_URL,
              zaloUrl: VBEE_ZALO_URL,
            }),
          }}
        />

        <div className="dialog-action">
          <CustomButton
            variant="contained"
            customStyle={{ borderRadius: '8px' }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
            onClick={onClose}
          >
            {t('gotIt')}
          </CustomButton>
        </div>
      </div>
    </StyledDialog>
  );
};

export default AutoRenewPriceAdjustmentPopup;
